import React from "react";
export const AddressBook = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1_2)">
        <mask id="mask0_1_2" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
          <path d="M0 0H16V17H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1_2)">
          <path
            d="M0.428571 5.3125C0.192857 5.3125 0 5.1332 0 4.91406V3.58594C0 3.3668 0.192857 3.1875 0.428571 3.1875H1.14286V1.59375C1.14286 0.713867 1.91071 0 2.85714 0H14.2857C15.2321 0 16 0.713867 16 1.59375V15.4062C16 16.2861 15.2321 17 14.2857 17H2.85714C1.91071 17 1.14286 16.2861 1.14286 15.4062V13.8125H0.428571C0.192857 13.8125 0 13.6332 0 13.4141V12.0859C0 11.8668 0.192857 11.6875 0.428571 11.6875H1.14286V9.5625H0.428571C0.192857 9.5625 0 9.3832 0 9.16406V7.83594C0 7.6168 0.192857 7.4375 0.428571 7.4375H1.14286V5.3125H0.428571ZM8.57143 4.25C7.31071 4.25 6.28571 5.20293 6.28571 6.375C6.28571 7.54707 7.31071 8.5 8.57143 8.5C9.83214 8.5 10.8571 7.54707 10.8571 6.375C10.8571 5.20293 9.83214 4.25 8.57143 4.25ZM4.57143 12.1125C4.57143 12.4645 4.92857 12.75 5.37143 12.75H11.7714C12.2143 12.75 12.5714 12.4645 12.5714 12.1125V11.475C12.5714 10.4191 11.4964 9.5625 10.1714 9.5625H9.99286C9.55357 9.73184 9.075 9.82812 8.57143 9.82812C8.06786 9.82812 7.58571 9.73184 7.15 9.5625H6.97143C5.64643 9.5625 4.57143 10.4191 4.57143 11.475V12.1125Z"
            fill="#775FD5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1_2">
          <rect width="16" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
